import { Directive, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
    selector: '[mobiletap]'
})
export class MobileTapDirective {
    @HostListener('tap', ['$event'])
    onTap(e) {
        if (e.tapCount === 2){
            this.doubleTap.emit(e);
        }
    }

    @Output() doubleTap = new EventEmitter();

    constructor() {}


}


// WEBPACK FOOTER //
// ./src/classes/MobileTap/mobiletap.directive.ts